export class WorldCanvas {
  constructor(canvas, bounds) {
    this.canvas = canvas;
    this.ctx = canvas.getContext("2d");
    this.updateBounds(bounds);
  }

  updateBounds(bounds) {
    this.bounds = bounds;
    this.scale = Math.min(
      this.canvas.width / bounds.width,
      this.canvas.height / bounds.height,
    );
    this.startX =
      (this.canvas.width - bounds.width * this.scale) / 2 -
      bounds.minX * this.scale;
    this.startY =
      (this.canvas.height - bounds.height * this.scale) / 2 -
      bounds.minY * this.scale;
  }

  toScreen(x, y) {
    return {
      x: this.startX + x * this.scale,
      y: this.startY + y * this.scale,
    };
  }

  toWorld(x, y) {
    return {
      x: (x - this.startX) / this.scale,
      y: (y - this.startY) / this.scale,
    };
  }

  transformPoints(points) {
    return points.map((p) => this.toScreen(p.x, p.y));
  }

  vectorToScreen(vx, vy) {
    const scale = Math.min(
      this.canvas.width / this.bounds.width,
      this.canvas.height / this.bounds.height,
    );
    return {
      x: vx * scale,
      y: vy * scale,
    };
  }
}
